import { render, staticRenderFns } from "./DeliverySearchList.vue?vue&type=template&id=2cc137b6&scoped=true&"
import script from "./DeliverySearchList.vue?vue&type=script&lang=js&"
export * from "./DeliverySearchList.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySearchList.vue?vue&type=style&index=0&id=2cc137b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc137b6",
  null
  
)

export default component.exports